var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 570.06 582.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fffadb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.76,365.72S-23.54,31.83,213.46,39.83C300.37,42.76,359.84,34,400.3,21.75c69.06-20.93,123.34,61,76.24,115.72-32.68,37.95-99.44,66.29-228,62.82a169.8,169.8,0,0,1-19.88-1.71C198.93,194.24,77.88,188.63,1.76,365.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.08,150.82s128.85,70,103.73,202.24a19.08,19.08,0,0,1-18.76,15.47H526.3s5.62-115.06-100.61-194.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.76,365.72l28.24.39s21.62-96.7,73-135l-65.58-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M485.4,125.74s63.23,53.79,73.65,133.94-73.65-67-73.65-67l-42-41.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.76,365.72S33.54,561.92,0,582.37c0,0,74.53-9,30-216.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555.66,361.44s-31.78,196.2,1.76,216.65c0,0-74.53-9-30-216.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.68,159.83l38.75-88A120.26,120.26,0,0,1,181.5,0H385.33A120.25,120.25,0,0,1,499.48,82.41L566.2,283.58,415.34,159.83,203,134.17,67,204.66,22.09,215.38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset13);
export default __webpack_public_path__ + "static/media/Asset 13.6de40a8b.svg";
export { ForwardRef as ReactComponent };